import "./SignupSuccess.css";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import { routeNames } from "../../constants/routeNames";

export const SignupSuccess = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setLoading } = useContext(LoadingContext);
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("THANK YOU");
    if (!location?.state?.redirected) {
      navigate(routeNames.LANDING);
    } else {
      setLoading(false);
    }
  });

  return (
    <div>
      <h2 className="title">
        Thank you for entering your details in the Share a Coke & Greene King
        Lucky Sips promotion.
      </h2>
      <p className="success-description">
        We'll send an email to your inbox shortly. Make sure you follow the link
        to activate your entry.
      </p>
      <p className="success-description ">
        If it's not come through you may need to check your junk folder.{" "}
      </p>
      <p className="success-description success-description-last">
        Please note if you're a winner, we'll use this email to send your prize!
      </p>
    </div>
  );
};
